import React from 'react';
import { getBreakpointFromManor } from 'ctm-components';
import { ResponsiveLayout } from '@comparethemarketau/manor-layout';

import { ContainerWrapper } from '../../container_wrapper';
import { EmptyStateFullPageXs } from './empty_state_full_page_xs';
import { EmptyStateFullPageSm } from './empty_state_full_page_sm';
import { EmptyStateFullPageMd } from './empty_state_full_page_md';
import { EmptyStateFullPageLg } from './empty_state_full_page_lg';

const EmptyStateFullPage = () => {
    const breakpoint = getBreakpointFromManor();
    const padding = paddings[breakpoint];
    return (
        <ContainerWrapper padding={padding} className={`test-emptyState-fullPage-${breakpoint}`}>
            <ResponsiveLayout is="xs"><EmptyStateFullPageXs /></ResponsiveLayout>
            <ResponsiveLayout is="sm"><EmptyStateFullPageSm /></ResponsiveLayout>
            <ResponsiveLayout is="md"><EmptyStateFullPageMd /></ResponsiveLayout>
            <ResponsiveLayout isFrom="lg"><EmptyStateFullPageLg /></ResponsiveLayout>
        </ContainerWrapper>
    );
};

export { EmptyStateFullPage };

const paddings = {
    xs: ['24', '16', '32', '16'],
    sm: ['44', '68', '52', '68'],
    md: ['32', '32', '32', '32'],
    lg: ['32', '0', '32', '0']
};
